import React from 'react'
import { Link } from 'react-router-dom'
import { FadeIn } from 'lib/ui/components'
import { AddressInput } from 'lib/types/core'
import { Title } from '../../../../components/Styled'
import { AddressForm } from '../../components/AddressForm'
import { FormContainer } from '../../components/Styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { useCustomerAddress, useSetDefaultShippingAddressOnCart } from 'hooks/customerAddress'

export const Add = () => {
  const { createAddress, isFetching } = useCustomerAddress()
  const { updateCheckoutAddress } = useSetDefaultShippingAddressOnCart()
  const handleSubmit = async ({ address }: { address: AddressInput}) => {
    createAddress({ address }).then(() => updateCheckoutAddress(address))
  }

  return (
    <FadeIn>
      <FormContainer>
        <div>
          <FlexWrapper className='flex-title'>
            <Title>
              New Address Information
            </Title>
            <Link to='/customer/account'>Back</Link>
          </FlexWrapper>
          <AddressForm
            onSubmit={handleSubmit}
            isFetching={isFetching}
          />
        </div>
      </FormContainer>
    </FadeIn>
  )
}
